/* globals define */
/*
  Purpose:
    - UI controller for the flyout on the L1 navigation list.

  Dependencies
    - Mustache
    - jQuery
    - Hoverintent
    - THD Namespace
*/

(function closure(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define('header.mask', ['../shared/utils'],
      function load(utils) {
        return factory(root, utils.default);
      });
  } else {
    // For non-AMD module, expose this to global (will also be useful for test cases)
    /*eslint-disable*/
    var _hfapp = THD.Utility.Namespace.createNamespace('THD.HFApp');
    _hfapp.mask = factory(root, utils);
    /*eslint-enable*/
  }
})(this, function factory(root, utils) {
  var mask = {};
  var privateMethods = {};

  /*
   * Private Methods
   */
  privateMethods.triggerHoverintent = function _triggerHoverintent(element) {
    element.dispatchEvent(new Event('hoverintent'));
    document.dispatchEvent(new Event('maskhoverintent'));
    document.dispatchEvent(new CustomEvent('showSimpleFlyout', {detail: {open:false}}));
    document.dispatchEvent(new CustomEvent('toggleMyAccountDrawer', {detail: {open:false}}));
  };

  privateMethods.get = function _getMask() {
    var maskElement = document.querySelector('.Mask');

    if (!maskElement) {
      maskElement = document.createElement('div');
      maskElement.classList.add('Mask');
      document.body.appendChild(maskElement);
      /**
       * Replacement for jquery hoverIntent plugin used below
       * Get top-level items from a dropdown menu, then
       * Set actions for mouse over and mouse leave
       */
      // TODO: this works because other things bring in SV, but it feels weird
      let HoverIntent = new SV.HoverIntent(document.querySelectorAll('.Mask'), {
        onEnter: function (targetItem) {
          privateMethods.triggerHoverintent(targetItem);
        },
        onExit: () => {}
      });

      utils.addListenersToAll(['click', 'touchend'], '.Mask', () => {
        document.dispatchEvent(new CustomEvent('showSimpleFlyout', { detail: { open: false } }));
        document.dispatchEvent(new CustomEvent('closeDrawer', { detail: { open: false } }));
        document.dispatchEvent(new CustomEvent('toggleMyAccountDrawer', { detail: { open: false } }));
      });
    }

    return maskElement;
  };

  // destroys the flyout and highlights
  mask.destroy = function _destroyMask() {
    if (document.body.querySelector('.Mask')) {
      document.body.removeChild(document.body.querySelector('.Mask'));
    }
  };

  mask.show = function _showMask(event, open) {
    if (event?.detail?.hasOwnProperty('open')) {
      open = event.detail.open;
    }
    var maskShown = (typeof open === 'undefined') ? true : open;
    privateMethods.get()?.classList?.toggle('Mask--open', maskShown);
  };

  mask.getPrivateMethods = function getPrivateMethods() {
    return privateMethods;
  };

  document.addEventListener('headerMask-show', mask.show);

  return mask;
});
